import React from 'react';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';

const PlusIconButton = ({ color, onClick, size }) => {
    const IconButtonStyled = styled(IconButton)({
        backgroundColor: color,
        padding: '1rem',
        boxShadow: '0px 4px 20px rgba(160, 170, 180, 0.5)',
        transition: 'all 0.1s ease',
        '&:hover': {
            transform: 'scale(1.03)',
            backgroundColor: color,
            boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)'
        },
    });

    return (
        <IconButtonStyled onClick={onClick}>
            <AddIcon sx={{ fontSize: size || '2.1rem', color: 'white' }} />
        </IconButtonStyled>
    );
};

export default PlusIconButton;
